import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from "../../components/header/header.component";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-policies',
  imports: [
    TranslatePipe,
    HeaderComponent
  ],
  templateUrl: './policies.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './policies.component.scss'
})
export class PoliciesComponent {

  back(){
    history.back();
  }

}
